<ng-container>
    <div [ngClass]="isPopupHidden === true ? 'd-none': ''" (clickOutside)="closePopup()" #FilterView
        class="px-2 dropdown-menu font-sm list-group list-group-flush rounded-corner">
        <div style="max-height: 500px; overflow-y: auto; width: 510px;">
            <ul class="nav nav-pills nav-justified" style="padding: 0px 10px;">
                <div class="nav-link" [ngClass]="currentlySelectedFilter === 'teams' ? 'active' : ''"
                    (click)="setCurrentlySelectedFilter('teams')" style="cursor: pointer;">{{teamsLabel}}</div>
                <div class="nav-link" [ngClass]="currentlySelectedFilter === 'status' ? 'active' : ''"
                    (click)="setCurrentlySelectedFilter('status')" style="cursor: pointer;">{{statusLabel}}</div>
                <div class="nav-link" [ngClass]="currentlySelectedFilter === 'events' ? 'active' : ''"
                    (click)="setCurrentlySelectedFilter('events')" style="cursor: pointer;">{{eventsLabel}}</div>
                <div class="nav-link" [ngClass]="currentlySelectedFilter === 'screenblocked-agents' ? 'active' : ''"
                    (click)="setCurrentlySelectedFilter('screenblocked-agents')" style="cursor: pointer;">Screenblocked
                </div>
            </ul>
            <div style="padding: 10px 10px 0px 10px;">
                <div *ngIf="currentlySelectedFilter === 'events'" style="width: calc(100% - 2px)">
                    <ngx-treeview [config]="eventsAndStatusTreeViewConfig" [items]="eventNames"
                        (selectedChange)="eventCheckedEvent($event)">
                    </ngx-treeview>
                </div>
                <div *ngIf="currentlySelectedFilter === 'status'" style="width: calc(100% - 2px)">
                    <ngx-treeview [config]="eventsAndStatusTreeViewConfig" [items]="statusNames"
                        (selectedChange)="statusCheckedEvent($event)">
                    </ngx-treeview>
                </div>
                <div *ngIf="currentlySelectedFilter === 'teams'" style="width: calc(100% - 2px)">
                    <ngx-treeview [config]="treeViewConfig" [items]="supervisorOrgHierarchy"
                        (selectedChange)="teamCheckedEvent($event)">
                    </ngx-treeview>
                </div>
                <div *ngIf="currentlySelectedFilter === 'screenblocked-agents'"
                    style="display: flex; justify-content: center;align-items: center; height: 60px;width: 100%;">
                    <span style="font-size: 15px;">{{screenblockDisclaimerLabel}}</span>
                </div>
            </div>
            <div style="display: flex;justify-content: space-around;align-items: center;">
                <button type="button" class="btn btn-reset" (click)="resetGlobalFilters()">{{resetLabel}}</button>
                <button type="button" class="btn btn-apply" (click)="applyGlobalFilter()">{{applyLabel}}</button>
            </div>
        </div>
    </div>
</ng-container>